export default {
  showVideoUpload: state => state.showVideoUpload,
  uploadVideoList: state => state.uploadVideoList,
};
